<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Bokforgruppeid" v-model.trim="item.Bokforgruppeid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Bokforgruppekode" name="Bokforgruppekode" :disabled="edit" v-model.trim="item.Bokforgruppekode" maxlength="10" required v-validate="'required|max:10'"/>
              <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="50" v-validate="'max:50'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomvaexport" name="Kontomvaexport" v-model.trim="item.Kontomvaexport" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomvafri" name="Kontomvafri" v-model.trim="item.Kontomvafri" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomva" name="Kontomva" v-model.trim="item.Kontomva" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomotkonto" name="Kontomotkonto" v-model.trim="item.Kontomotkonto" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomellom" name="Kontomellom" v-model.trim="item.Kontomellom" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-4" label="Kontomellommvafri" name="Kontomellommvafri" v-model.trim="item.Kontomellommvafri" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-6" label="Kunstavggrl" name="Kunstavggrl" v-model.trim="item.Kunstavggrl" maxlength="10" v-validate="'max:10'"/>
              <TheTextInput containerClassName="cell large-6" label="KunstavggrlMotkonto" name="KunstavggrlMotkonto" v-model.trim="item.KunstavggrlMotkonto" maxlength="10" v-validate="'max:10'"/>
              <TheSwitchInput v-model="item.Kunstneravgift" labelTrue="Kunstavgift" labelFalse="Ingen kunstavgift" trueValue="T" falseValue="F"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerBokforgruppeEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.item.Kunstneravgift = 'F'

        this.setFormLoading(false)
      } else {
        this.service.view(this.$route.params.id)
          .then((response) => {
            this.item = response.data
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn bokforgruppe')

            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            this.item.Bokforgruppekode = this._.toUpper(this.item.Bokforgruppekode)

            this.service.save(this.item.Bokforgruppeid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Bokforgruppe er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Bokforgruppekode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerBokforgruppeEdit.vue